import { axiosInstance } from './axiosInstance'
import { getAccumulatedBom } from '../../../helpers/getAccumulatedBom'
import { type APIConfig } from '../apiTypes'
import type * as DynamakerContract from '../../../integration/DynamakerContract'

const axios = axiosInstance()

export type DsaPricehelperRepsonse = any

export const postDsaPricehelper = async <T = any>(args: {
  apiConfigs: APIConfig
  data: {
    bom: DynamakerContract.BOM
    configId: string
    content: Record<PropertyKey, any>
    meta: DynamakerContract.Metadata
  }
  onSuccess: (response: { data: DsaPricehelperRepsonse }) => T
}): Promise<T> => {
  const {
    onSuccess,
    apiConfigs: { scensumBaseUrl },
    data: { bom, configId, content, meta },
  } = args

  const accumulatedBom = getAccumulatedBom(bom)

  const data = {
    ConfigurationType: 'mok',
    ConfigurationId: configId,
    Meta: {
      Title: '(intentionally left blank)',
      TitleLong: '(intentionally left blank)',
    },
    ConfigurationSections: accumulatedBom.map((section: any) => ({
      Type: section.type,
      Position: section.position,
      OwnerPosition: section.ownerPosition ?? null,
      Meta: {
        Title: content.bom[section.type]?.title ?? '(intentionally left blank)',
        TitleLong: content.bom[section.type]?.titleLong
          ? `${content.bom[section.type].titleLong} ${meta.buildingArea.toString().replace('.', ',')} m²`
          : '(intentionally left blank)',
      },
      // TODO ts
      Articles: section.articles.map((item: any) => ({
        Sku: item.erpItemNumber,
        Quantity: item.quantity,
        ...('configData' in item &&
          item.configData && {
            Type: 'configProduct',
            // only works for single config product in configResult, equivalent to current implementation in lfc-frontend
            PricingInfo: item.configData.configResult.configProducts[0].pricingInfo,
          }),
      })),
    })),
  }

  return await axios<DsaPricehelperRepsonse>({
    method: 'post',
    url: `${scensumBaseUrl}/api/v1/dsapricehelper`,
    data,
  })
    .then((response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}
